import React from 'react';
import ListingPreview from '../../../shared/templates/ListingTemplate/listing-preview';

export default function ServicePreview(props) {
  return (
    <ListingPreview {...props} section="services" />
  );
}